module.exports = (Vue) ->

  Vue.component 'recaptcha',                    require('shared/components/recaptcha')
  Vue.component 'settings-loader',              require('shared/components/settings_loader')
  Vue.component 'window-listener',              require('shared/components/window_listener')

  Vue.component 'popups-container',             require('shared_frontend/components/popups_container')
  Vue.component 'popup',                        require('shared_frontend/components/popup')
  Vue.component 'popup-content',                require('shared_frontend/components/popup_content')

  Vue.component 'popup-countries-map',          require('./popup_countries_map')

  Vue.component 'page-bottom-static-container', require('./page_bottom_static_container')
  Vue.component 'footer-bottom-spacer',         require('./footer_bottom_spacer')
  Vue.component 'navigation-wrapper',           require('./navigation_wrapper')
  Vue.component 'school-login-form',            require('./school_login_form')
  Vue.component 'lightbox',                     require('./lightbox')
  Vue.component 'lightbox-item',                require('./lightbox_item')
  Vue.component 'lazy-image',                   require('./lazy_image')
  Vue.component 'accordion-toggle',             require('./accordion_toggle')
  Vue.component 'accordion-item',               require('./accordion_item')
  Vue.component 'hero-rotating-image',          require('./hero_rotating_image')
  Vue.component 'countries-map',                require('./countries_map')
  Vue.component 'countries-map-container',      require('./countries_map_container')
  Vue.component 'contact-form-registration',    require('./contact_form_registration')
  Vue.component 'contact-form-default',         require('./contact_form_default')
  Vue.component 'contact-form-become-partner',  require('./contact_form_become_partner')


// WEBPACK FOOTER //
// ./assets/js/frontend/components/globals.coffee